import { useTranslation } from 'next-i18next';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { IWarehouseManagement } from '@/modules/warehouseManagement/shared/types';
import Input from '@/modules/warehouseManagement/warehouses/components/InboundDelivery/CreateEditInboundDelivery/Steps/Inputs/Input';
import { Typography } from '@/shared/components/atoms';
import ConfirmationModal from '@/shared/components/molecules/ConfirmationModal';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Bag from '~/images/shared/Bag.svg';

const InboundDeliveryInputs = () => {
  const { t } = useTranslation();

  const { openModal } = useModal();

  const { control } =
    useFormContext<IWarehouseManagement.ICreateInboundDeliveryFormValues>();

  const { append, remove, fields } = useFieldArray({
    control,
    name: 'products',
  });

  const handleAppend = () => {
    append({
      product: null,
      categoryId: null,
      countOfPackages: null,
      packageSize: null,
      packagePrice: null,
      packageUnit: null,
      productionDate: null,
      expiryDate: null,
    });
  };

  const handleRemove = (index: number) => {
    openModal(
      <ConfirmationModal
        variant='danger'
        header={t('delete-input-confirmation')}
        confirmText={t('delete')}
        onConfirm={() => remove(index)}
        buttonsAlignment='col'
      />
    );
  };

  return (
    <div>
      <div className='mb-32 flex items-center gap-8'>
        <Bag width='24' height='24' />
        <Typography weight='semiBold'>{t('Inputs')}</Typography>
      </div>
      {fields.map((field, index) => (
        <Input
          key={field.id}
          index={index}
          handleAppend={handleAppend}
          handleRemove={() => handleRemove(index)}
        />
      ))}
    </div>
  );
};

export default InboundDeliveryInputs;
